import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24VideoChat = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M15.5 4.5a2 2 0 0 1 2 2v1.286l1.468-.733a1.75 1.75 0 0 1 2.274.65l.073.133c.098.194.158.404.178.62l.007.162v6.764a1.75 1.75 0 0 1-2.384 1.631l-.148-.066-1.468-.733V17.5a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2zm0 1.5h-11a.5.5 0 0 0-.492.41L4 6.5v11a.5.5 0 0 0 .41.492L4.5 18h11a.5.5 0 0 0 .492-.41L16 17.5v-11a.5.5 0 0 0-.41-.492zM6.9 8.31c.365-.485 1.08-.525 1.518-.088l.763.763c.4.4.406 1.038.016 1.428a.85.85 0 0 0 .014 1.206l1.438 1.438a.85.85 0 0 0 1.205.013c.39-.39 1.03-.383 1.428.017l.763.763c.438.437.397 1.152-.087 1.517-1.151.81-2.728.659-3.74-.353l-2.965-2.965c-1.011-1.011-1.162-2.588-.357-3.733zm12.802.063-.064.022-2 1a.25.25 0 0 0-.132.168l-.006.055v4.764a.25.25 0 0 0 .091.193l.047.03 2 1a.25.25 0 0 0 .356-.166l.006-.057V8.618a.3.3 0 0 0-.026-.112.25.25 0 0 0-.272-.133"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24VideoChat$1 = Svg24VideoChat;

export { Svg24VideoChat$1 as default };
